import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import s from './LanguageDropdown.module.css';

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'ru', label: 'RUS' },
    { code: 'fas', label: 'FAS' },
    // Add additional languages if needed
  ];

  // Find the current language for display
  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  // Ref for detecting clicks outside the dropdown
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const selectLanguage = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);

    // Set RTL or LTR direction based on selected language
    const isRtl = code === 'fas'; // Farsi uses RTL
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';

    // Optional: Change font or add class to body for additional styling
    document.body.className = isRtl ? 'rtl' : 'ltr';
  };


  return (
    <div className={s.dropdownWrapper} ref={dropdownRef}>
      <button className={s.dropdownButton} onClick={toggleDropdown}>
        {currentLanguage.label}
        <span className={s.arrow}>{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <ul className={s.dropdownList}>
          {languages.map(lang => (
            <li
              key={lang.code}
              className={s.dropdownItem}
              onClick={() => selectLanguage(lang.code)}
            >
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
